module.exports = __webpack_public_path__ + "static/amount-tile-54925057ffc27260723eaf2df62472fe.png";